<ng-container *transloco="let t">
  <span
    class="price"
    [class.promo]="!!priceValue.promoPrice"
    [innerHTML]="
      (priceValue.promoPrice ? priceValue.promoPrice : priceValue.regularPrice)
        | yesCurrency: priceValue.currency
    "
  >
  </span>
  @if (!!priceValue.promoPrice) {
    <div class="content-special-price">
      <span class="label regular-price">
        {{ t('Regular price') }}:
        <span
          class="price-value"
          [innerHTML]="priceValue.regularPrice | yesCurrency: priceValue.currency"
        >
        </span>
      </span>
      <span class="label omnibus-price-container">
        {{ t('Lowest price before discount') }}:
        <span
          class="price-value"
          [innerHTML]="priceValue.omnibusPrice | yesCurrency: priceValue.currency"
        >
        </span>
      </span>
    </div>
  }
</ng-container>
